import React from 'react';

export default () => (
  <div className="leading-[3rem] flex items-center text-foreground-lighter text-[2rem]">
    &#8250;
  </div>
);
